import React, { Component } from "react";
import {
    HeaderContainer,
    HeaderTitle,
    Logo,
    Titles,
    ProfileContainer,
    HeaderWrap,
    LogoutWrap,
    TitleWrap,
} from "./Header.styled";
// import { withRouter } from "react-router-dom";
import { HeaderTitles } from "./HeaderTitles";
import { Container } from "static/coreStyles/global.styled";
import { Avatar, Popover } from "antd";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { userLogout } from "actions/login";
import { getInitials } from "utility/helperFunctions";

const popoverStyles = {
    overlay: {
        // border: '2px solid red',
        padding: 0,
        margin: 0

    },
    inner: {
        // border: '2px solid blue',
        padding: 0,
        margin: 0,

    },
    title: {
        // border: '2px solid green',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '4px 8px',
        fontSize: '14px'
    },
    content: {
        // border: '2px solid yellow',
        // display: 'flex',
        // justifyContent: 'center',
        // alignItems: 'center',
    },
    logoutButton: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#6528d8',
        color: 'white',
        border: 'none',
        padding: '4px 8px',
        borderRadius: '4px',
        cursor: 'pointer',
        fontSize: '12px',
        fontWeight: '500',
        width: '100%',
        textAlign: 'center',
    }
}

class Header extends Component {
    constructor(props) {
        super(props);
        this.container = React.createRef();
        this.state = { peopleActive: false, show: false, visible: false };
        this.exclusionPaths = ["/login"];
    }
    isActive = (path) => {
        return this.props.location.pathname.includes(path);
    };
    redirect = (path) => {
        if (this.props.location.pathname !== path) this.props.history.push(path);
    };

    handleLogout = () => {
        this.hide();
        this.props.userLogout(this.props.history);
    };
    hide = () => {
        this.setState({
            visible: false,
        });
    };

    handleVisibleChange = (visible) => {
        this.setState({ visible });
    };

    render() {
        const currentUser = this.props.currentUser;
        if (!currentUser) return null;
        return (
            <>
                {this.exclusionPaths.indexOf(this.props.location.pathname) < 0 && (
                    <HeaderWrap>
                        <Container>
                            <HeaderContainer>
                                <Logo src={require("static/images/logo.svg")} alt="logo" />
                                <Titles>
                                    {HeaderTitles.map((title, index) => {
                                        return (
                                            <HeaderTitle
                                                key={index}
                                                active={this.isActive(title.url)}
                                            >
                                                <div
                                                    onClick={() => {
                                                        this.redirect(title.url);
                                                    }}
                                                    className="nav-link"
                                                >
                                                    <i>
                                                        {this.isActive(title.url) ? (
                                                            <img src={title.activeIcon} alt="" />
                                                        ) : (
                                                            <img src={title.inactiveIcon} alt="" />
                                                        )}
                                                    </i>
                                                    <span>{title.title}</span>
                                                    {this.props[String(title.title).toLowerCase()] ? (
                                                        <small>
                                                            {this.props[String(title.title).toLowerCase()]}
                                                        </small>
                                                    ) : null}
                                                </div>
                                            </HeaderTitle>
                                        );
                                    })}
                                </Titles>


                                <ProfileContainer>
                                    <Popover
                                        overlayClassName="profile-popover"
                                        overlayStyle={popoverStyles.overlay}
                                        overlayInnerStyle={popoverStyles.inner}

                                        content={
                                            <div
                                                style={popoverStyles.content}
                                            >

                                                <LogoutWrap
                                                    onClick={this.handleLogout}
                                                    style={popoverStyles.logoutButton}
                                                >
                                                    Logout
                                                </LogoutWrap>
                                            </div>
                                        }
                                        title={
                                            <div style={popoverStyles.title}>
                                                <TitleWrap>
                                                    <h3 style={{ margin: 0 }}>
                                                        {currentUser && currentUser.email
                                                            ? currentUser.email
                                                            : ""}
                                                    </h3>
                                                    <h4 style={{ margin: 0, textAlign: 'center' }}>
                                                        {(currentUser.firstName || "") +
                                                            " " +
                                                            (currentUser.lastName || "")}
                                                    </h4>
                                                </TitleWrap>
                                            </div>
                                        }
                                        trigger="click"
                                        placement="bottomRight"
                                        visible={this.state.visible}
                                        onVisibleChange={this.handleVisibleChange}
                                    >
                                        <Avatar icon={currentUser.profilePic}>
                                            {getInitials(currentUser.firstName, currentUser.lastName)}
                                        </Avatar>
                                    </Popover>
                                </ProfileContainer>


                            </HeaderContainer>
                        </Container>
                    </HeaderWrap>
                )}
            </>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        userLogout: bindActionCreators(userLogout, dispatch),
    };
}
function mapStateToProps({
    Login: { currentUser },
    User: {
        pagination: { totalCount: userTotalCount },
    },
    Ride: {
        pagination: { totalCount: rideTotalCount },
    },
    Group: {
        pagination: { totalCount: groupTotalCount },
    },
}) {
    return {
        currentUser,
        users: userTotalCount,
        rides: rideTotalCount,
        groups: groupTotalCount,
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Header));
